(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  function setupFooterAccordion() {
    const isMobile = window.innerWidth <= 749;
    const headings = document.querySelectorAll('.footer-block__heading');

    headings.forEach((heading) => {
      const content = heading.nextElementSibling;

      // अगर next element newsletter block है तो skip कर दो
      if (content && content.classList.contains('footer-block__newsletter')) {
        return;
      }

      // Clean up previous event listeners by cloning
      const newHeading = heading.cloneNode(true);
      heading.parentNode.replaceChild(newHeading, heading);

      if (isMobile) {
        // Collapse all by default
        content.style.maxHeight = '0';
        content.style.overflow = 'hidden';
        content.style.transition = 'max-height 0.3s ease';

        newHeading.style.cursor = 'pointer';

        newHeading.addEventListener('click', function () {
          const isOpen = newHeading.classList.contains('is-open');

          // Close all other accordions (skip newsletter as well)
          document.querySelectorAll('.footer-block__heading').forEach((h) => {
            const c = h.nextElementSibling;
            if (c && !c.classList.contains('footer-block__newsletter')) {
              c.style.maxHeight = '0';
              h.classList.remove('is-open');
            }
          });

          // Open clicked one if not already open
          if (!isOpen) {
            content.style.maxHeight = content.scrollHeight + 'px';
            newHeading.classList.add('is-open');
          }
        });
      } else {
        // Reset for desktop
        content.style.maxHeight = 'none';
        content.style.overflow = 'visible';
        newHeading.classList.remove('is-open');
        newHeading.style.cursor = 'default';
      }
    });
  }

  // Initial run
  setupFooterAccordion();

  // Re-run on window resize
  window.addEventListener('resize', setupFooterAccordion);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var testimonialSliderInitialized = false;

    function initializeSlickSlider() {
      if (testimonialSliderInitialized) return;
      var $slider = $('.testimonial-slides');
      if (!$slider.length || $slider.hasClass('slick-initialized')) return;

      $slider.slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 990,
            settings: { slidesToShow: 2, slidesToScroll: 1, autoplay: true, autoplaySpeed: 1000 }
          },
          {
            breakpoint: 750,
            settings: { slidesToShow: 1, slidesToScroll: 1, arrows: true, autoplay: true, autoplaySpeed: 5000 }
          },
          {
            breakpoint: 480,
            settings: { slidesToShow: 1, slidesToScroll: 1, arrows: true, autoplay: true, autoplaySpeed: 5000 }
          }
        ]
      });

      testimonialSliderInitialized = true;
    }

    function deferInit() {
      if (typeof $ === 'function' && $.fn.slick) {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(initializeSlickSlider, { timeout: 2000 });
        } else {
          setTimeout(initializeSlickSlider, 300);
        }
      } else {
        setTimeout(deferInit, 100);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', deferInit);
    } else {
      deferInit();
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usps-info"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var uspSliderInitialized = false;

    function initializeSlickSlider() {
      if (uspSliderInitialized) return;
      var $slider = $('.uspSlider');
      if (!$slider.length || $slider.hasClass('slick-initialized')) return;

      $slider.slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1440,
            settings: { slidesToShow: 4, autoplay: true, autoplaySpeed: 1000 }
          },
          {
            breakpoint: 1200,
            settings: { slidesToShow: 3, autoplay: true, autoplaySpeed: 1000 }
          },
          {
            breakpoint: 990,
            settings: { slidesToShow: 2, autoplay: true, autoplaySpeed: 1000 }
          },
          {
            breakpoint: 640,
            settings: { slidesToShow: 1, autoplay: true, autoplaySpeed: 1000 }
          }
        ]
      });

      uspSliderInitialized = true;
    }

    function deferInit() {
      if (typeof $ === 'function' && $.fn.slick) {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(initializeSlickSlider, { timeout: 2000 });
        } else {
          setTimeout(initializeSlickSlider, 300);
        }
      } else {
        setTimeout(deferInit, 100);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', deferInit);
    } else {
      deferInit();
    }

  })();

  } catch(e) { console.error(e); }
})();
})();
